import {
  AlignRightOutlined,
  AreaChartOutlined,
  ContactsOutlined,
  DashboardOutlined,
  EditOutlined,
  FilePdfOutlined,
  FormOutlined,
  HeartOutlined,
  LikeOutlined,
  LoginOutlined,
  LogoutOutlined,
  MessageOutlined,
  NotificationOutlined,
  PicLeftOutlined,
  PlusOutlined,
  ShopOutlined,
  UserAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Drawer, Dropdown, Modal, Typography } from "antd";
import BurgerMenu from "../BurgerMenu";
import AccountIndex from "apps/Account/AccountIndex";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetUserInfoes } from "apps/CustomerPanel/Profile/ClientSideStates";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import FavoriteCount from "./FavoriteCount";
import NotificationCount from "./NotificationCount";
import MessageCount from "./MessageCount";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { setBackEndUlr } from "helpers/SetBackEndUrl";

const Options = () => {
  const { Text } = Typography;
  const [isShowBurgerMenu, setIsShowBurgerMenu] = useState(false);
  const [isShowAccountModal, setIsShowAccountModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const handleRemoveQueryParam = (param: string) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete(param);
    setSearchParams(newSearchParams);
  };
  const { userInfoes } = useSelector((state: RootState) => state.profile);

  // userInfoes?.store?.map((storeItem:any) => {
  //   console.log("st", storeItem.photoUrl);
  // });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const generateMenuItems = (userType: number) => {
    const baseItems: any[] = [
      {
        key: "profile",
        label: "Profil",
        icon: <UserOutlined />,
      },
      {
        type: "divider",
      },
      {
        key: "adManagement",
        label: `İlan Oluştur`,
        icon: <FormOutlined />,
      },

    ];

    const type1and3Items: any[] = [
      {
        type: "divider",
      },
      {
        key: "myAdverts",
        label: `İlanlarım`,
        icon: <PicLeftOutlined />,
      },


      ...(userInfoes?.userType === 3
        ? [
          {
            type: "divider",
          },
          {
            key: "invitationList",
            label: `Davet Listesi`,
            icon: <LikeOutlined />,
          },
        ]
        : []),
      {
        type: "divider",
      },
      {
        key: "invoice",
        label: `Faturalar`,
        icon: <FilePdfOutlined />,
      },
      {
        type: "divider",
      },
      {
        key: "favorite",
        label: `Favori`,
        icon: <HeartOutlined />,
      },
      {
        type: "divider",
      },
      {
        key: "messages",
        label: `Mesaj`,
        icon: <MessageOutlined />,
      },
      {
        type: "divider",
      },
      {
        key: "notification",
        label: `Bildirim`,
        icon: <NotificationOutlined />,
      },
    ];

    const type1Items: any[] = [
      {
        type: "divider",
      },
      {
        key: "invitationList",
        label: `Davet Listesi`,
        icon: <LikeOutlined />,
      },
      {
        type: "divider",
      },
      {
        key: "alarm",
        label: `Alarm`,
        icon: <DashboardOutlined />,
      },
    ];

    const type2Items: any[] = [
      {
        type: "divider",
      },
      {
        key: "shoppingCenter",
        label: `Mağaza Yönetimi`,
        icon: <ShopOutlined />,
      },
      {
        type: "divider",
      },

      {
        key: "contract",
        label: `Sözleşme Yönetimi`,
        icon: <ContactsOutlined />,
      },
      {
        type: "divider",
      },
      {
        key: "userManagement",
        label: `Kullanıcı Yönetimi`,
        icon: <UserAddOutlined />,
      },
      {
        type: "divider",
      },
      {
        key: "mls",
        label: "PPS Portföy Paylaşım Sistemi",
        icon: <EditOutlined />,
      },
      {
        type: "divider",
      },
      {
        key: "report",
        label: `Rapor`,
        icon: <AreaChartOutlined />,
      },
      {
        type: "divider",
      },
      {
        key: "alarm",
        label: `Alarm`,
        icon: <DashboardOutlined />,
      },

    ];

    const otherItems: any[] = [
      {
        type: "divider",
      },

      {
        key: "logout",
        label: <Text className="!text-sm !text-red-500">Çıkış Yap</Text>,
        icon: <LogoutOutlined className="!text-sm !text-red-500" />,
      },
    ];

    // Kullanıcı tipine göre menü öğelerini döndür
    switch (userType) {
      case 1:
        return [...baseItems, ...type1and3Items, ...type1Items, ...otherItems];
      case 2:
        return [
          ...baseItems,
          ...type2Items,
          ...type1and3Items,

          ...otherItems,
        ];
      case 3:
        return [...baseItems, ...type1and3Items, ...otherItems];
      default:
        return [...baseItems, ...otherItems]; // Diğer kullanıcı tipleri için varsayılan menü
    }
  };

  const items = generateMenuItems(userInfoes?.userType);

  return (
    <>
      <div className={`!flex justify-between lg:!justify-end items-center !h-full ${userInfoes ? "!gap-4" : "!gap-0"} lg:!gap-4 !w-full`}>
        {userInfoes ? (
          <>
            <NotificationCount />
            <MessageCount />
            <FavoriteCount />

            <div
              className=" !bg-transparent !flex items-center  !cursor-pointer "
              onClick={() => { }}
            >
              <Dropdown
                menu={{
                  items,
                  onClick: ({ key }: { key: string }) => {
                    if (key !== "logout") {
                      navigate(`/admin/panel?activePanelMenu=${key}`);
                    } else {
                      localStorage.removeItem("access_token");
                      dispatch(handleSetUserInfoes({ data: null }));
                      navigate("/");
                      // openNotificationWithIcon(
                      //   "success",
                      //   "Başarıyla Çıkış Yapıldı"
                      // );
                    }
                  },
                }}
                overlayClassName="w-[200px]"
              >
                {/* <UserOutlined className="!text-black !text-lg" /> */}

               

                {userInfoes?.store?.photoUrl ? (
                  <LazyLoadImage
                    wrapperWidth="50px"
                    wrapperHeight="50px"
                    src={setBackEndUlr() + "/" + userInfoes.store[6].photoUrl}
                    alt=""
                    imageClassName="!rounded-md"
                  />
                ) : (
                  <div className="w-[30px] h-[30px] rounded-full bg-gray-300 flex items-center justify-center text-white font-semibold text-sm">
                    {`${userInfoes.name?.[0] || ""}${userInfoes.surname?.[0] || ""}`.toUpperCase()}
                  </div>
                )}

              </Dropdown>
            </div>
            {/* Bu menüyü eids koduna sahip kullanıcıların göreceği şekilde düzenledim */}
            {
              userInfoes?.type === '2'  ? (
                <div
                  className="!bg-transparent !flex items-center gap-2 !cursor-pointer "
                  onClick={() => {
                    navigate(`/admin/panel?activePanelMenu=mls`);
                  }}
                >
                  <ContactsOutlined className="!text-black !text-xl" />
                  <Text className=" ">PPS</Text>
                </div>
              ) : (<span></span>)
            }



            <Button
              type="primary"
              className="!bg-[#FFC502] rounded-xl"
              onClick={() => {
                navigate(`/admin/panel?activePanelMenu=adManagement`);
              }}
            >
              {/* <PlusOutlined /> */}
              <Text className="!text-dark w-[80px]">İlan Ver</Text>
            </Button>
            <div className=" ">
              <AlignRightOutlined
                onClick={() => {
                  setIsShowBurgerMenu(true);
                }}
                className="!text-xl hover:cursor-pointer !text-black"
              />
            </div>
          </>
        ) : (
          <>
            <div
              onClick={() => {
                openNotificationWithIcon(
                  "error",
                  "Favorilere Görmeniz İçin Giriş Yapınız"
                );
              }}
            >
              <HeartOutlined className="!text-xl hover:cursor-pointer " />
            </div>
            <Button
              type="link"
              className=" !bg-transparent !pr-0 !pl-0"
              onClick={() => {
                setSearchParams({ sayfa: "kayit-ol" });
                setIsShowAccountModal(true);
              }}
            >
              <UserAddOutlined className="!text-black" />
              <Text>Kayıt Ol</Text>
            </Button>
            <Button
              type="link"
              className="!bg-transparent !pl-0"
              onClick={() => {
                setSearchParams({ sayfa: "giris-yap" });
                setIsShowAccountModal(true);
              }}
            >
              <LoginOutlined className="!text-black" />
              <Text className=" ">Giriş Yap</Text>
            </Button>

            <div className="" >
              <AlignRightOutlined
                onClick={() => {
                  setIsShowBurgerMenu(true);
                }}
                className="!text-xl hover:cursor-pointer !text-black"
              />
            </div>
          </>
        )}
      </div>
      <Drawer
        open={isShowBurgerMenu}
        onClose={() => {
          setIsShowBurgerMenu(false);
        }}
      >
        <BurgerMenu
          onFinish={() => {
            setIsShowBurgerMenu(false);
          }}
        />
      </Drawer>
      <Modal
        open={isShowAccountModal}
        onCancel={() => {

          setIsShowAccountModal(false);
        }}
        footer={false}
      >
        <AccountIndex
          onFinish={() => {

            setIsShowAccountModal(false);
          }}
        />
      </Modal>
    </>
  );
};

export default Options;
